module.exports = __webpack_public_path__ + "static/media/blood-3.f1a4ac89.png";